const get_api = () => {
  let API = process.env.REACT_APP_BASE_URL + "/api";

  return {
    API,
  };
};

export const { API } = get_api();
